import { Index as DIndex } from "./dekstop/Index"
import { Index as MIndex } from "./devices/mobile/Index"
import { Index as TIndex } from "./devices/tablet/Index"
import { VM } from "../../../../core/VM"

const view = VM()

export const Order = () => { 
    return (
        view === '' ? 
            // DESKTOP
            <DIndex/>
        : view === "/devices/mobile" ?  
            // MOBILE
            <MIndex/>
            //TABLET
        :
            <TIndex/>
    )
}
